import CircularProgress from '@mui/material/CircularProgress'
import PropTypes from 'prop-types'

import styles from './Spinner.module.css'

const SIZE_MAP = { sm: 24, md: 40, lg: 60 }

export const Spinner = ({ texto, size = 'md', color = 'primary', fullPage = false }) => {
  return (
    <div className={`${styles.spinnerContainer} ${fullPage ? styles.fullPage : ''}`}>
      <CircularProgress size={SIZE_MAP[size]} color={color} />
      {texto && <span className={styles.texto}>{texto}</span>}
    </div>
  )
}

Spinner.propTypes = {
  texto: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'info',
    'success',
    'warning',
    'inherit'
  ]),
  fullPage: PropTypes.bool
}
